import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: 'todo', pathMatch: 'full' },
    { path: 'calendar', loadChildren: './calendar/calendar-page.module#CalendarPageModule' },
    { path: 'calendar-event', loadChildren: './calendar-event/calendar-event-page.module#CalendarEventPageModule' },
    { path: 'survey', loadChildren: './survey/survey-page.module#SurveyPageModule'},
    { path: 'charts', loadChildren: './charts-example/charts-example.module#ChartsExampleModule'},
    { path: 'connect', loadChildren: './connect/connect-page.module#ConnectPageModule'},
    { path: 'life-sections', loadChildren: './life-section/life-section-page.module#LifeSectionPageModule'},
    { path: 'life-section', loadChildren: './life-section-edit/life-section-edit-page.module#LifeSectionEditPageModule'},
    { path: 'slogan-editor', loadChildren: './slogan-editor/slogan-editor.module#SloganEditorModule'},
    { path: 'evaluate-day', loadChildren: './day-evaluation/day-evaluation-page.module#DayEvaluationPageModule'},
    { path: 'evaluate/timeframe', loadChildren: './timeframe-evaluation/timeframe-evaluation-page.module#TimeframeEvaluationPageModule'},
    { path: 'statistics', loadChildren: './statistics/statistic-page.module#StatisticPageModule'},
    { path: 'todo', loadChildren: './todo/todo-page.module#TodoPageModule'},
    { path: 'event-templates', loadChildren: './event-templates/event-templates-page.module#EventTemplatesPageModule'},
    { path: 'event-template', loadChildren: './event-template-edit/event-template-edit-page.module#EventTemplateEditPageModule'},
    { path: 'event-template-selection', loadChildren: './event-template-selection/event-template-selection-page.module#EventTemplateSelectionPageModule'},
    { path: 'podcasts', loadChildren:'./exercise/exercise-page.module#ExercisePageModule'},
    { path: 'settings', loadChildren:'./settings/settings.module#SettingsModule'},
    { path: 'form', loadChildren:'./generic-form/generic-form.module#GenericFormModule'},
    { path: 'medical-certificate', loadChildren: './settings/medical-certificate/medical-certificate.module#MedicalCertificatePageModule' },
    { path: 'help-videos', loadChildren: './help-videos/help-videos.module#HelpVideosPageModule' },
    { path: 'tutorial', loadChildren: './app-tour-page/app-tour-page.module#AppTourPageModule' },
    { path: 'termination-page', loadChildren: './termination/termination.module#TerminationPageModule' },
    { path: 'final-survey', loadChildren: () => new Promise(() => { window.open('https://www.survio.com/survey/d/T5Q3N4R6W3F9X3B4M', '_system', 'location=yes') })},
    { path: 'user-goals', loadChildren: () => import('./user-goals/user-goals.module').then( m => m.UserGoalsPageModule)},
    { path: 'weekly-skin-entry', loadChildren: () => import('./weekly-skin-entry/weekly-skin-entry.module').then( m => m.WeeklySkinEntryPageModule)},
    { path: 'faq', loadChildren: () => import('./faq/faq.module').then( m => m.FaqPageModule)},
    { path: 'skincare-questions', loadChildren: () => import('./skincare-questions/skincare-questions.module').then( m => m.SkincareQuestionsPageModule)},
    { path: 'notification-settings', loadChildren: () => import('./notification-settings/notification-settings.module').then( m => m.NotificationSettingsPageModule)}


];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
